import React from 'react';
import { useNavigation } from '../../config/NavigationContext';
import { useUser } from '../../config/UserContext';
import styles from './GenreTag.module.scss';

const GenreTag = ({ genre }) => {
  const { handleSearchWithQuery } = useNavigation();
  const { currentUser } = useUser();

  const handleTagClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Only allow search if user is authenticated
    if (currentUser) {
      handleSearchWithQuery(genre);
    }
  };

  const isAuthenticated = !!currentUser;

  return (
    <span
      className={`${styles.genreTag} ${!isAuthenticated ? styles.disabled : ''}`}
      onClick={handleTagClick}
      role="button"
      tabIndex={isAuthenticated ? 0 : -1}
      onKeyDown={(e) => {
        if (isAuthenticated && (e.key === 'Enter' || e.key === ' ')) {
          handleTagClick(e);
        }
      }}
      title={
        isAuthenticated ? `Search for "${genre}"` : 'Sign in to search by genre'
      }
    >
      # {genre}
    </span>
  );
};

export default GenreTag;
